import { render, staticRenderFns } from "./card-item.vue?vue&type=template&id=55f2dea3&scoped=true&"
import script from "./card-item.vue?vue&type=script&lang=js&"
export * from "./card-item.vue?vue&type=script&lang=js&"
import style0 from "./card-item.vue?vue&type=style&index=0&id=55f2dea3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f2dea3",
  null
  
)

export default component.exports